import { render, staticRenderFns } from "./check_list.vue?vue&type=template&id=4068f72c"
import script from "./check_list.vue?vue&type=script&lang=js"
export * from "./check_list.vue?vue&type=script&lang=js"
import style0 from "./check_list.vue?vue&type=style&index=0&id=4068f72c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports